(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buy-now-button')) {
    class BuyNowButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick(event) {
        event.preventDefault();

        if (this.button.disabled) return;

        const form = this.closest('form') || document.querySelector('form[action^="/cart/add"]');
        if (!form) return;

        const formData = new FormData(form);

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              this.button.disabled = false;
              this.button.removeAttribute('aria-busy');
              this.dispatchEvent(
                new CustomEvent('buy-now:error', {
                  bubbles: true,
                  detail: { message: data.description || data.message },
                })
              );
              return;
            }

            window.location.href = window.Shopify?.routes?.root
              ? `${window.Shopify.routes.root}checkout`
              : '/checkout';
          })
          .catch(() => {
            this.button.disabled = false;
            this.button.removeAttribute('aria-busy');
          });
      }
    }

    customElements.define('buy-now-button', BuyNowButton);
  }
  } catch(e) { console.error(e); }
})();

})();
